import React from 'react';

import i18next from 'core/i18n';
import { PhaseSection } from 'shared';
import { GuaranteeData } from 'features/brazil-grower/components/shared/GuaranteeData/GuaranteeData';

export const GuaranteeDataSection: React.FunctionComponent = () => {
  return (
    <PhaseSection title={i18next.t('guaranteeData')}>
      <GuaranteeData />
    </PhaseSection>
  );
};
